import $ from 'jquery'
import {
  prepareChessboard,
  loadNextConfiguration,
  plotArrow,
  showCapturedPieces,
  showMagnus,
  validateMove,
  restrictMove,
  getSubstring
} from '../../utils';
import User from '../../classes/user';
import ChessBoard from '../../components/chessBoard';
import { ACTIVITY_COMPLETION_AUDIO, WRONG_ANSWER_AUDIO } from '../../utils/constants';

/**
* @name lesson14Assignment1
* @function
* @param {config}
* @description: activity related task
*/
export function lesson14Assignment1(config) {
  let offsetFromx = null,
    offsetFromy = null,
    offsetTox = null,
    offsetToy = null;

  if (config.offset) {
    offsetFromx = config.offset[0]
    offsetFromy = config.offset[1]
    offsetTox = config.offset[2]
    offsetToy = config.offset[3]
  }

  let afterLoad = function () {
    prepareChessboard(config);

    $('#myCanvas').addClass('show').removeClass('hide');
    var c = document.getElementById('myCanvas');
    var ctx = c.getContext('2d');
    ctx.clearRect(0, 0, c.width, c.height);

    plotArrow(ctx, config.from, config.to, offsetFromx, offsetFromy, offsetTox, offsetToy, null, null, '#FFA500');
  }
  const chessConfig = {
    config: {
      position: config.position,
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
* @name lesson14AssignmentMovePieces
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson14Assignment1MovePieces(config) {
  let moveSpeed = 1000,
    offsetFromx = null,
    offsetFromy = null,
    offsetTox = null,
    offsetToy = null;

  if (config.offset) {
    offsetFromx = config.offset[0]
    offsetFromy = config.offset[1]
    offsetTox = config.offset[2]
    offsetToy = config.offset[3]
  };

  let afterLoad = function () {
    prepareChessboard(config);
    $('#myCanvas').addClass('show').removeClass('hide');
    var c = document.getElementById('myCanvas');
    var ctx = c.getContext('2d');
    ctx.clearRect(0, 0, c.width, c.height);

    plotArrow(ctx, config.from, config.to, offsetFromx, offsetFromy, offsetTox, offsetToy);

    setTimeout(function () {
      ctx.clearRect(0, 0, c.width, c.height);
      ChessBoard.board.move(getSubstring(config.from, config.to));
      if (config.capture) {
        let move = {
          captured: config.capture.capturedPiece.charAt(1),
          color: config.capture.capturingPiece.charAt(0)
        }
        setTimeout(function () {
          showCapturedPieces(config.capture.capturingPiece, move)
        }, moveSpeed)
      }
    }, 1000);

    setTimeout(function () {
      ChessBoard.board.position(config.finalPosition);
    }, 2000);
    $(document).trigger('audio-play', ACTIVITY_COMPLETION_AUDIO)
    // showMagnus({
    //   data: `nice job ${User.user.name}!`,
    //   styleClass: 'sm',
    //   position: 'left'
    // })
    loadNextConfiguration(3000, config.next, false)
  }

  const chessConfig = {
    config: {
      position: config.position,
      draggable: true,
      sparePieces: true,
      moveSpeed: moveSpeed
    },
    afterLoad: afterLoad,

  }
  return chessConfig;
}

/**
* @name lesson14Assignment2
* @function
* @param {config}
* @description: activity related task
*/
export function lesson14Assignment2(config) {
  let next = config.next,
    finalMoves = config.final,
    attemptsMade = 2,
    moveSpeed = 1000,
    from = config.from,
    to = config.to;

  let afterLoad = function () {
    prepareChessboard(config);
    if (config.from != null) {
      setTimeout(function () {
        ChessBoard.board.move(`${from}-${to}`);
      }, 1000);
      if (config.MagnusText) {
        showMagnus({
          data: config.MagnusText,
          position: 'left'
        })
      }
      loadNextConfiguration(3000, next, true)
    }
  }

  let onDragStart = function (source, piece, position, orientation) {
    return restrictMove(piece, config.restrictMoveOf)
  }

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    return validateMove(source, target, piece, false)
  }

  var onSnapEnd = function (source, target, piece) {
    let boardFen = ChessBoard.board.fen();

    if (finalMoves.includes(boardFen)) {
      showMagnus({
        data: `${config.MagnusText} ${User.user.name}!`,
        position: 'left',
        styleClass: 'xs'
      })
      loadNextConfiguration(2000, next, true)
    }
    else if (attemptsMade > 0) {
      $(document).trigger('audio-play', WRONG_ANSWER_AUDIO)
      showMagnus({
        data: `This is not a pawn chain.<br/> Try again.<br/> Chances remaining: ${attemptsMade} `,
        position: 'left',
        styleClass: 'xl'
      })
      --attemptsMade;
      setTimeout(function () {
        showMagnus({
          data: 'Move the piece to the correct <br/> position to create a pawn chain.',
          position: 'left',
          styleClass: 'md'
        })
        ChessBoard.board.position(config.position);
        ChessBoard.game = new window.Chess(config.position + config.initialMove);
        return 'snapback';
      }, 3000)
    }
    else {
      loadNextConfiguration(2000, config.failedAttemptMove, false)
      ChessBoard.board.position(config.position);
      ChessBoard.game = new window.Chess(config.position + config.initialMove);
      setTimeout(function () {
        showMagnus({
          data: 'This could be one of the moves.',
          position: 'left'
        })
      }, 3000)
    }
  };

  const chessConfig = {
    config: {
      position: config.position,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
      sparePieces: true,
      moveSpeed: moveSpeed
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}






// WEBPACK FOOTER //
// ./src/lessons/lesson_14/assignments.js